import { RouteConfig } from "vue-router";

import Layout from "@/layout/index.vue";

const cusServiceSysRouter: RouteConfig = {
  path: "/cus-service",
  name: "cus-service",
  component: Layout,
  meta: {
    title: "客服管理",
    icon: "setting",
    permission: "Pages.CustomerService"
  },
  children: [

    {
      path: "/wxPhoneParent",
      name: "/wxPhoneParent",
      component: () => import('@/views/customerServiceSys/wxPhoneParent.vue'),
      meta: {
        title: "微信电话绑定查询",
        permission: "Pages.CustomerService.WxPhoneQuery"
      }
    },
    {
      path: "/customerService",
      name: "/customerService",
      component: () => import('@/views/customerServiceSys/index.vue'),
      meta: {
        title: "学校用户分析",
        permission: "Pages.CustomerService.Analysis"
      }
    },
    {
      path: "/onlineService",
      name: "/onlineService",
      component: () => import('@/views/customerServiceSys/onlineService.vue'),
      meta: {
        title: "在线客服",
        permission: "Pages.CustomerService.Char"
      }
    },
  ]
};

export default cusServiceSysRouter;
